import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import EmblaCarousel from "embla-carousel";
gsap.registerPlugin(ScrollTrigger);

gsap.to(".scroll-down", {
    scrollTrigger: {
        trigger: "#top",
        start: "60px top",
        //markers: true
    },
    opacity: 0
});

//const target = document.querySelector(".u-kr");
// const target2 = document.querySelector(".u-kr2");
//const heroTarget = document.querySelector("#u-kr");

/*
gsap.to(target, {
    scrollTrigger: {
        trigger: heroTarget, // siden
        start: "10% 10%",              // x (hvor langt ned på trigger som skal være utgangspunkt for at animasjon treffes (y))  y (viewport animasjon start)
        toggleActions: "play none none reverse",
        markers: true,
    },
    onStart: () => target.classList.add("is-active"),
});


ScrollTrigger.create({
    trigger: heroTarget,
    start: "10% 10%",
    toggleClass: {
        targets: ".u-kr, .info-01",
        className: "is-active",
    },
    once: true,
    //toggleActions: "play none none reverse",
    markers: true,
});



gsap.to(target2, {
    scrollTrigger: {
        trigger: heroTarget, // siden
        start: "20% 10%",              // 30px etter start scroll
        toggleActions: "play none none reverse",
        // markers: true,
    },
    onStart: () => target2.classList.add("is-active"),
});

 */

function revealOnce({
                        trigger,
                        start,
                        targets,
                        markers = false,
                    }) {
    ScrollTrigger.create({
        trigger,
        start,
        toggleClass: {
            targets,
            className: "is-active",
        },
        once: true,
        markers: markers
    });
}

revealOnce({
    trigger: "#u-kr",
    start: "0% 15%",
    targets: ".u-kr, .info-01",
    markers: false
});

revealOnce({
    trigger: "#u-kr",
    start: "15% 15%",
    targets: ".u-kr2, .info-02",
    markers: false
});

revealOnce({
    trigger: "#u-kr",
    start: "30% 10%",
    targets: ".learnvideo",
    markers: false
});

/*
const videoWrapper = document.querySelector(".learnvideo");

gsap.to(videoWrapper, {
    scrollTrigger: {
        trigger: "#u-kr", // siden
        start: "50% 30%",              // 30px etter start scroll
        once: true,
        markers: true,
    },
    onStart: () => videoWrapper.classList.add("is-active"),
});
*/

// Embla Carousel initialization for slideshow
function initSlideshow() {
    const slideshowElements = document.querySelectorAll('.embla-slideshow');
    
    slideshowElements.forEach((slideshowElement) => {
        const viewport = slideshowElement.querySelector('.embla__viewport');
        if (!viewport) return;
        
        const embla = EmblaCarousel(viewport, {
            loop: false,
            align: 'start',
            dragFree: false,
        });
        
        // Navigation buttons (under slideshow)
        const prevButton = slideshowElement.querySelector('.embla__prev');
        const nextButton = slideshowElement.querySelector('.embla__next');

        // Navigation buttons inside each slide (tekstboks)
        const prevButtonsText = slideshowElement.querySelectorAll('.embla__prev-text');
        const nextButtonsText = slideshowElement.querySelectorAll('.embla__next-text');
        
        if (prevButton) {
            prevButton.addEventListener('click', () => embla.scrollPrev());
        }
        
        if (nextButton) {
            nextButton.addEventListener('click', () => embla.scrollNext());
        }
        
        // Update button states (både under slideshow og inne i tekstboksene)
        const updateButtonStates = () => {
            if (prevButton) {
                prevButton.disabled = !embla.canScrollPrev();
            }
            if (nextButton) {
                nextButton.disabled = !embla.canScrollNext();
            }

            prevButtonsText.forEach((btn) => {
                btn.disabled = !embla.canScrollPrev();
            });
            nextButtonsText.forEach((btn) => {
                btn.disabled = !embla.canScrollNext();
            });
        };
        
        embla.on('select', updateButtonStates);
        updateButtonStates();
        
        // Dots navigation
        const dotsContainer = slideshowElement.querySelector('.embla__dots');
        if (dotsContainer) {
            const slides = embla.slideNodes();
            const dots = [];
            
            // Create dots
            slides.forEach((_, index) => {
                const dot = document.createElement('button');
                dot.className = 'embla__dot w-2 h-2 rounded-full bg-current opacity-30 transition-opacity';
                dot.setAttribute('aria-label', `Gå til slide ${index + 1}`);
                dot.addEventListener('click', () => embla.scrollTo(index));
                dotsContainer.appendChild(dot);
                dots.push(dot);
            });
            
            // Update active dot
            const updateDots = () => {
                const selectedIndex = embla.selectedScrollSnap();
                dots.forEach((dot, index) => {
                    if (index === selectedIndex) {
                        dot.classList.remove('opacity-30');
                        dot.classList.add('opacity-100');
                    } else {
                        dot.classList.remove('opacity-100');
                        dot.classList.add('opacity-30');
                    }
                });
            };
            
            embla.on('select', updateDots);
            updateDots();
        }
        
        // Navigasjonsknapper inne i tekstboksene (en per slide)
        prevButtonsText.forEach((btn) => {
            btn.addEventListener('click', () => embla.scrollPrev());
        });

        nextButtonsText.forEach((btn) => {
            btn.addEventListener('click', () => embla.scrollNext());
        });
    });
}

// Initialize slideshow when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshow);
} else {
    initSlideshow();
}
